import {IAssetInfo} from "./Assets";

export interface IAssetLibrary {
	user: Record<string, IAssetInfo>,
	organization: Record<string, IAssetInfo>,
}

export enum AssetCollections {
	User,
	Organization,
	Foreign,
}

export enum AssetSubTrees {
	InUse = "InUse",
	Project = "Project",
	User = "User",
	Organization = "Organization",
}